<template>
  <div class="brand-list">
    <div class="brand" v-for="brand in brands" :key="brand.title">
      <div v-if="brand.content.length" class="brand-class">
        <SectionTitle
          :title="brand.title"
          :more-link="'homepage-brandlist'"
          hide-more
        />
      </div>
      <div class="brand-links">
        <IconLinkSlider :iconLinks="brand.content" />
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import IconLinkSlider from '@/components/IconLinkSlider.vue'

export default {
  name: 'BrandList',
  components: {
    SectionTitle,
    IconLinkSlider,
  },
  data: () => ({
    brands: [],
  }),
  methods: {
    async getBrandList() {
      try {
        const res = await api.getHomepage()
        if (res.data.brandBlock && res.data.brandBlock.length) {
          this.brands.push(...res.data.brandBlock)
        } else {
          this.$bus.$emit('callAllert', {
            messageContent: '查無品牌資料',
            callback: () => {
              this.$router.push({ name: 'home' })
            },
          })
        }
      } catch (error) {
        this.$bus.$emit('callAllert', {
          messageContent: '取得資料失敗',
          callback: () => {
            this.$router.push({ name: 'home' })
          },
        })
      }
    },
  },
  created() {
    const brandList = localStorage.getItem('brandList')
    if (brandList && brandList.length) {
      this.brands.push(...JSON.parse(brandList))
    } else {
      this.getBrandList()
    }
  },
}
</script>

<style lang="scss" scoped>
.brand-list {
  padding: 20px 18px;

  .brand {
    margin-bottom: 20px;
  }
}
</style>
